<template>
  <div class="container-fluid py-4">
    <form
      @submit.prevent="createCompany"
      class="needs-validation"
      novalidate
      enctype="multipart/form-data"
    >
      <!-- Company Details Section -->
      <div class="card shadow-sm border-0 mb-4">
        <div class="card-header bg-light">
          <h5 class="mb-0">📑 Company Details</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <!-- Company Name -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Company Name</label>
              <input
                v-model="company.company_name"
                type="text"
                class="form-control"
                required
              />
            </div>

            <!-- Company Email -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Email</label>
              <input
                v-model="company.company_email"
                type="email"
                class="form-control"
              />
            </div>

            <!-- Company Phone -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Phone</label>
              <input
                v-model="company.company_phone"
                type="text"
                class="form-control"
              />
            </div>

            <!-- Company Location -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Location</label>
              <input
                v-model="company.company_location"
                type="text"
                class="form-control"
              />
            </div>

            <!-- Company Type -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Company Type</label>
              <select
                v-model="company.company_type"
                class="form-select"
                required
              >
                <option value="">Select Type</option>
                <option value="Hospital">Hospital</option>
                <option value="Clinic">Clinic</option>
                <option value="Pharmacy">Pharmacy</option>
              </select>
            </div>

            <!-- Package ID -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Package</label>
              <select v-model="company.package_id" class="form-select" required>
                <option value="">Select Package</option>
                <option v-for="pkg in packages" :key="pkg.id" :value="pkg.id">
                  {{ pkg.name }}
                </option>
              </select>
            </div>

            <!-- Country -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Country</label>
              <input
                v-model="company.country"
                type="text"
                class="form-control"
              />
            </div>

            <!-- Address -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Address</label>
              <input
                v-model="company.address"
                type="text"
                class="form-control"
              />
            </div>

            <!-- Currency -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Currency</label>
              <input
                v-model="company.currency"
                type="text"
                class="form-control"
              />
            </div>

            <!-- Branch Group -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Branch Group</label>
              <input
                v-model="company.branch_group"
                type="text"
                class="form-control"
              />
            </div>

            <!-- Logo Upload -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Logo</label>
              <input
                type="file"
                @change="handleLogoUpload"
                class="form-control"
                accept="image/*"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Admin Details Section -->
      <div class="card shadow-sm border-0 mb-4">
        <div class="card-header bg-light">
          <h5 class="mb-0">👤 Admin Details</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Admin Name</label>
              <input
                v-model="admin.name"
                type="text"
                class="form-control"
                required
              />
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Admin Email</label>
              <input
                v-model="admin.email"
                type="email"
                class="form-control"
                required
              />
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Admin Phone</label>
              <input v-model="admin.phone" type="text" class="form-control" />
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Password</label>
              <input
                v-model="admin.password"
                type="password"
                class="form-control"
                required
              />
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Confirm Password</label>
              <input
                v-model="admin.confirm_password"
                type="password"
                class="form-control"
                required
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="text-end">
        <button type="submit" class="btn btn-primary px-4">
          <i class="fas fa-save me-2"></i> Save Company
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { generalApiUploadRequest } from "../../api/apiIndex";
// generalApiRequest,
export default {
  name: "CreateOrganization",
  data() {
    return {
      company: {
        company_name: "",
        company_email: "",
        company_phone: "",
        company_location: "",
        company_type: "",
        package_id: "",
        country: "",
        address: "",
        currency: "",
        branch_group: "",
        logo: null,
      },
      admin: {
        name: "",
        email: "",
        phone: "",
        password: "",
        confirm_password: "",
      },
      packages: [
        { id: 1, name: "Basic" },
        { id: 2, name: "Pro" },
        { id: 3, name: "Enterprise" },
      ],
    };
  },
  methods: {
    handleLogoUpload(event) {
      this.company.logo = event.target.files[0];
    },
    async createCompany() {
      if (this.admin.password !== this.admin.confirm_password) {
        alert("Passwords do not match");
        return;
      }

      const formData = new FormData();
      for (const key in this.company) {
        formData.append(key, this.company[key]);
      }
      for (const key in this.admin) {
        formData.append(`admin_${key}`, this.admin[key]);
      }

      try {
        // generalApiUploadRequest(myurl, data, call_class)
        const response = await generalApiUploadRequest(
          "create_company",
          formData,
          1
        );
        alert(response.message || "Company created successfully!");
        this.resetForm();
      } catch (error) {
        console.error(error);
        alert("Failed to create company");
      }
    },
    resetForm() {
      for (let key in this.company) {
        this.company[key] = key === "logo" ? null : "";
      }
      for (let key in this.admin) {
        this.admin[key] = "";
      }
    },
  },
};
</script>

<style scoped>
.card-header {
  border-bottom: 1px solid #e4e4e4;
}
label {
  font-weight: 500;
}
</style>
